import pythonApiClient from './pythonBaseApi';

// ── Empleados ──────────────────────────────────────────────────────────────

const empleadosApi = {
  /** Listar empleados de un proyecto con búsqueda opcional */
  getEmpleados: (proyectoId, search = '') => {
    const params = new URLSearchParams({ proyecto_id: proyectoId });
    if (search) params.append('search', search);
    return pythonApiClient.get(`/rrhh/empleados?${params}`);
  },

  /** Obtener empleado por ID */
  getEmpleadoById: (id) =>
    pythonApiClient.get(`/rrhh/empleados/${id}`),

  /** Crear empleado */
  createEmpleado: (data) =>
    pythonApiClient.post('/rrhh/empleados', data),

  /** Actualizar empleado */
  updateEmpleado: (id, data) =>
    pythonApiClient.put(`/rrhh/empleados/${id}`, data),

  /** Eliminar empleado */
  deleteEmpleado: (id) =>
    pythonApiClient.delete(`/rrhh/empleados/${id}`),

  // ── Catálogos RRHH ───────────────────────────────────────────────────────

  /** Obtener regímenes laborales */
  getRegimenes: (activoOnly = false) =>
    pythonApiClient.get(`/rrhh/regimenes-empleado?activo_only=${activoOnly}`),

  /** Obtener régimen por ID */
  getRegimenById: (id) =>
    pythonApiClient.get(`/rrhh/regimenes-empleado/${id}`),

  /** Crear régimen */
  createRegimen: (data) =>
    pythonApiClient.post('/rrhh/regimenes-empleado', data),

  /** Actualizar régimen */
  updateRegimen: (id, data) =>
    pythonApiClient.put(`/rrhh/regimenes-empleado/${id}`, data),

  /** Eliminar régimen */
  deleteRegimen: (id) =>
    pythonApiClient.delete(`/rrhh/regimenes-empleado/${id}`),

  getEstados: () =>
    pythonApiClient.get('/rrhh/estados-empleado'),

  // ── Catálogos compartidos (endpoints ya existentes en el backend) ─────────

  /** Obtener tipos de documentos de identidad */
  getTiposDocumentos: () =>
    pythonApiClient.get('/mantenimientos/tipo-documentos-identidad'),

  /** Obtener géneros */
  getGeneros: () =>
    pythonApiClient.get('/mantenimientos/generos'),

  /** Obtener catálogos bancarios y de pensiones */
  getCatalogosBancarios: () =>
    pythonApiClient.get('/rrhh/empleados/catalogos/pensiones-bancos'),
};

export default empleadosApi;
